const tryToGetCountryCodeFromWindow = () => {
  if (window && window.onecomConfig) {
    return window.onecomConfig.countryCode;
  }
  return null;
};

const initialState = tryToGetCountryCodeFromWindow();

function reducer(state = initialState) {
  return state;
}

export const name = "countryCode";
export default { [name]: reducer };
